// extracted by mini-css-extract-plugin
export default {"activeButton":"style_activeButton__Y-6uU","inactiveButton":"style_inactiveButton__a2QW-"};